import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { useLegalDraftStatus } from '@/config/legalStatus';

const LegalDraftNotice = ({ docName }) => {
  const isDraft = useLegalDraftStatus();
  if (isDraft !== true) return null;
  return (
    <div className="rounded-xl border-2 border-red-300 bg-red-50 text-red-900 px-5 py-4 mb-8" data-testid="legal-draft-notice" role="alert">
      <p className="font-bold flex items-center gap-2 text-base">
        <AlertTriangle className="w-5 h-5 flex-shrink-0" />
        DRAFT — NOT YET IN EFFECT
      </p>
      <p className="text-sm mt-1">
        This {docName} is a draft containing placeholder content and is not yet in effect.
        No commitments are made under it while the platform is in development.
        The final document will be published here once legal review is complete.
      </p>
    </div>
  );
};

export default LegalDraftNotice;
